<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col sm="10">
            <h3>Gerenciar Arquivos</h3>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-form v-on:submit.prevent="onSubmit">
          <b-row>
            <b-col cols="12">
              <br />
              <label>Regulamento do Projeto: *</label>
              <span
                class="icon-info"
                v-b-popover.hover.top="'Permitidos apenas arquivos .pdf'"
                title="Informação"
              ></span>
              <b-form-group
                label-for="nome-input"
                invalid-feedback="Imagem é obrigatório"
              >
                <b-row>
                  <b-col cols="11">
                    <b-form-file
                      ref="file-input-1"
                      browse-text="Selecione"
                      placeholder="Selecione o documento"
                      v-on:change="uploadDoc1"
                      :state="chkState('regulamento_projeto')"
                    ></b-form-file>
                  </b-col>
                  <b-col cols="1">
                    <a
                      class="btn btn-md btn-secondary action"
                      title="Deletar imagem"
                      v-on:click="clearFiles(1)"
                    >
                      <i class="icon-trash"></i>
                    </a>
                  </b-col>
                </b-row>
                <b-form-invalid-feedback
                  id="input1LiveFeedback3"
                  :state="chkState('regulamento_projeto')"
                  >Arquivo é obrigatório.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col v-if="imagemAtual1" cols="12">
              <label>Arquivo atual:</label></br>
              <b-button
                variant="primary"
                @click="
                  abrirDocumento(imagemAtual1)
                "
                ><i class="fa fa-download"></i>Regulamento do Projeto</b-button
              >
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <br />
              <label>Termo do Voluntariado: *</label>
              <span
                class="icon-info"
                v-b-popover.hover.top="'Permitidos apenas arquivos .pdf'"
                title="Informação"
              ></span>
              <b-form-group
                label-for="nome-input"
                invalid-feedback="Imagem é obrigatório"
              >
                <b-row>
                  <b-col cols="11">
                    <b-form-file
                      ref="file-input-2"
                      browse-text="Selecione"
                      placeholder="Selecione o documento"
                      v-on:change="uploadDoc2"
                      :state="chkState('termo_voluntario')"
                    ></b-form-file>
                  </b-col>
                  <b-col cols="1">
                    <a
                      class="btn btn-md btn-secondary action"
                      title="Deletar imagem"
                      v-on:click="clearFiles(2)"
                    >
                      <i class="icon-trash"></i>
                    </a>
                  </b-col>
                </b-row>
                <b-form-invalid-feedback
                  id="input1LiveFeedback3"
                  :state="chkState('termo_voluntario')"
                  >Arquivo é obrigatório.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col v-if="imagemAtual2" cols="12">
              <label>Arquivo atual:</label></br>
              <b-button
                variant="primary"
                @click="
                  abrirDocumento(imagemAtual2)
                "
                ><i class="fa fa-download"></i>Termo do Voluntariado</b-button
              >
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <br />
              <label>Guia do Encontro: *</label>
              <span
                class="icon-info"
                v-b-popover.hover.top="'Permitidos apenas arquivos .pdf'"
                title="Informação"
              ></span>
              <b-form-group
                label-for="nome-input"
                invalid-feedback="Imagem é obrigatório"
              >
                <b-row>
                  <b-col cols="11">
                    <b-form-file
                      ref="file-input-3"
                      browse-text="Selecione"
                      placeholder="Selecione o documento"
                      v-on:change="uploadDoc3"
                      :state="chkState('guia_encontro')"
                    ></b-form-file>
                  </b-col>
                  <b-col cols="1">
                    <a
                      class="btn btn-md btn-secondary action"
                      title="Deletar imagem"
                      v-on:click="clearFiles(3)"
                    >
                      <i class="icon-trash"></i>
                    </a>
                  </b-col>
                </b-row>
                <b-form-invalid-feedback
                  id="input1LiveFeedback3"
                  :state="chkState('guia_encontro')"
                  >Arquivo é obrigatório.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col v-if="imagemAtual3" cols="12">
              <label>Arquivo atual:</label></br>
              <b-button
                variant="primary"
                @click="
                  abrirDocumento(imagemAtual3)
                "
                ><i class="fa fa-download"></i> Guia do Encontro</b-button
              >
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <br />
              <label>Ebook Mães Unidas: *</label>
              <span
                class="icon-info"
                v-b-popover.hover.top="'Permitidos apenas arquivos .pdf'"
                title="Informação"
              ></span>
              <b-form-group
                label-for="nome-input"
                invalid-feedback="Imagem é obrigatório"
              >
                <b-row>
                  <b-col cols="11">
                    <b-form-file
                      ref="file-input-4"
                      browse-text="Selecione"
                      placeholder="Selecione o documento"
                      v-on:change="uploadDoc4"
                      :state="chkState('ebook')"
                    ></b-form-file>
                  </b-col>
                  <b-col cols="1">
                    <a
                      class="btn btn-md btn-secondary action"
                      title="Deletar imagem"
                      v-on:click="clearFiles(4)"
                    >
                      <i class="icon-trash"></i>
                    </a>
                  </b-col>
                </b-row>
                <b-form-invalid-feedback
                  id="input1LiveFeedback3"
                  :state="chkState('ebook')"
                  >Arquivo é obrigatório.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col v-if="imagemAtual4" cols="12">
              <label>Arquivo atual:</label></br>
              <b-button
                variant="primary"
                @click="
                  abrirDocumento(imagemAtual4)
                "
                ><i class="fa fa-download"></i> Ebook Mães Unidas</b-button
              >
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-form-group label="Link do curso de Voluntariado: *">
                <b-input-group class="mb-6">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-link"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Link do curso"
                    v-model="$v.form.curso_voluntario.$model"
                    :state="chkState('curso_voluntario')"
                    autofocus
                  />
                  <b-form-invalid-feedback id="input1LiveFeedback4"
                    >Link é obrigatório.</b-form-invalid-feedback
                  >
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="5" offset-md="3">
            <b-button block variant="primary" v-on:click="onSubmit">
              <i class="fa fa-check"></i>&nbsp;
              <span>Salvar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </span>
</template>

<script>
import 'v-markdown-editor/dist/v-markdown-editor.css'
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Editor from 'v-markdown-editor'
import CKEditor from 'ckeditor4-vue'
import SessionStorage from '@/services/session-storage'

miniToastr.init()
Vue.use(Editor)
Vue.use(CKEditor)

const formShape = {
  regulamento_projeto: '',
  termo_voluntario: '',
  guia_encontro: '',
  ebook: '',
  curso_voluntario: ''
}

export default {
  name: 'Cadastro',
  components: {
    AuthTemplate,
    VueSelect,
    Editor
  },
  mixins: [validationMixin],
  validations: {
    form: {
      ebook: {
        required: requiredIf(function (nestedModel) {
          return !this.imagemAtual4
        })
      },
      regulamento_projeto: {
        required: requiredIf(function (nestedModel) {
          return !this.imagemAtual1
        })
      },
      guia_encontro: {
        required: requiredIf(function (nestedModel) {
          return !this.imagemAtual3
        })
      },
      termo_voluntario: {
        required: requiredIf(function (nestedModel) {
          return !this.imagemAtual2
        })
      },
      curso_voluntario: {
        required
      }
    }
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') !== 'A') {
      this.$router.push('/')
    }
  },
  data () {
    return {
      form: Object.assign({}, formShape),
      id: 0,
      imagemAtual1: false,
      imagemAtual2: false,
      imagemAtual3: false,
      imagemAtual4: false,
      DeleteImagens: false,
      editorConfig: {
        removePlugins: 'elementspath,resize,codesnippet'
      }
    }
  },
  mounted () {
    this.loadCurso()
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    abrirDocumento (item) {
      window.open(item, '_blank')
    },
    salvar () {
      let form = this.$v.form

      let data = {
        id: this.id,
        regulamento_projeto: form.regulamento_projeto.$model,
        termo_voluntario: form.termo_voluntario.$model,
        guia_encontro: form.guia_encontro.$model,
        ebook: form.ebook.$model,
        curso_voluntario: form.curso_voluntario.$model
      }

      Vue.http
        .post('api/arquivosmenu', data)
        .then((response) => {
          if (response.body.success) {
            miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })

            miniToastr.success(
              'Arquivos salvos com sucesso!',
              'Sucesso!',
              7000
            )

            this.loadCurso()
          } else {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
            miniToastr.error(response.body.msg, 'Alerta', 5000)
          }
        })
        .catch((e) => {
          if (e.body.data[0].ebook) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
            miniToastr.error(e.body.data[0].ebook[0], 'Alerta', 5000)
          }
          if (e.body.data[0].regulamento_projeto) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
            miniToastr.error(e.body.data[0].regulamento_projeto[0], 'Alerta', 5000)
          }
          if (e.body.data[0].termo_voluntario) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
            miniToastr.error(e.body.data[0].termo_voluntario[0], 'Alerta', 5000)
          }
          if (e.body.data[0].guia_encontro) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
            miniToastr.error(e.body.data[0].guia_encontro[0], 'Alerta', 5000)
          }
          if (e.body.data[0].curso_voluntario) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
            miniToastr.error(e.body.data[0].curso_voluntario[0], 'Alerta', 5000)
          }

          console.log(e.body.data[0])
        })
    },
    loadCurso () {
      Vue.http.get('api/arquivosmenu').then((response) => {
        this.form.curso_voluntario = response.body.data.data[0] ? response.body.data.data[0].curso_voluntario : null
        this.imagemAtual1 = response.body.data.data[0] ? response.body.data.data[0].regulamento_projeto : null
        this.imagemAtual2 = response.body.data.data[0] ? response.body.data.data[0].termo_voluntario : null
        this.imagemAtual3 = response.body.data.data[0] ? response.body.data.data[0].guia_encontro : null
        this.imagemAtual4 = response.body.data.data[0] ? response.body.data.data[0].ebook : null
        this.id = response.body.data.data[0] ? response.body.data.data[0].id : null
      })
    },
    clearFiles (id) {
      this.$refs['file-input-' + id].reset()
      switch (id) {
        case 1: this.imagemAtual1 = null; this.$v.form.regulamento_projeto.$model = null; break
        case 2: this.imagemAtual2 = null; this.$v.form.termo_voluntario.$model = null; break
        case 3: this.imagemAtual3 = null; this.$v.form.guia_encontro.$model = null; break
        case 4: this.imagemAtual4 = null; this.$v.form.ebook.$model = null; break
      }
      this.DeleteImagens = true
    },
    uploadDoc1 (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.$v.form.regulamento_projeto.$model = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    uploadDoc2 (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.$v.form.termo_voluntario.$model = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    uploadDoc3 (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.$v.form.guia_encontro.$model = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    uploadDoc4 (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files

      if (!arquivo.length) {
        return false
      }

      let reader = new FileReader()

      reader.onload = (evento) => {
        this.$v.form.ebook.$model = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    confirmar () {
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja continuar?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            this.salvar()
          }
        })
        .catch((erro) => {
          console.log(erro)
        })
    },
    onSubmit () {
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
img.preview {
  width: 200px;
  background-color: white;
  border: 1px solid #ddd;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/arquivosMenu/ArquivosMenu.vue